import { Link } from 'react-router-dom';
import React from 'react';
import './CategoryButton.css';

const CategoryButton = ({category, currentCategory}) => {

    //console.log("카테고리: ",category, "현재 카테고리: ", currentCategory);
    const isActive = category.storeType === currentCategory;

        return (
        <>
        <Link to={`/store/${category.storeType}`}>
            <div className={"category-button-active-" + isActive}>
                <div className='category-name'>{category.name}</div>
            </div>
        </Link>
            
        </> 
)};

export default CategoryButton;